export default __webpack_public_path__ + "img/d31367ecb887d32fc7649a2fe51b1144.svg";